import React from "react";
import PropTypes from "prop-types";
import { SpinnerLoader } from "Teacher/routes/ToddleAnalytics/components";

const SpinLoader = ({
  children,
  isLoading,
  size,
  borderWidth,
  borderColor,
  borderTopColor,
  speed,
  className,
  containerStyle,
}) => {
  return isLoading ? (
    <div style={containerStyle}>
      <SpinnerLoader
        size={size}
        borderWidth={borderWidth}
        borderColor={borderColor}
        borderTopColor={borderTopColor}
        speed={speed}
        className={className}
      />
    </div>
  ) : (
    children
  );
};

SpinLoader.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool.isRequired,
  size: PropTypes.number,
  borderWidth: PropTypes.number,
  borderColor: PropTypes.string,
  borderTopColor: PropTypes.string,
  speed: PropTypes.number,
  className: PropTypes.string,
  containerStyle: PropTypes.object,
};

SpinLoader.defaultProps = {
  children: null,
  size: 16,
  borderWidth: 3,
  borderColor: "var(--border-secondary)",
  borderTopColor: "var(--interactive-secondary)",
  speed: 1,
  className: "",
  containerStyle: {},
};

export default SpinLoader;
